import React from 'react';
import { ImageBackground, Platform, View, Linking } from 'react-native'
import OButton, { OAboutButton } from '../olonkho-fw';
import { oStyles } from '../olonkho-styles';
import { Button } from 'react-native-elements';

export default function Home({ navigation }) {
    return (
        <View style={ oStyles.main_container }>
          <ImageBackground
            source={require('../../assets/background.png')}
            style={ oStyles.background }
            resizeMode={ (Platform.OS === 'web' && 'cover') || ('stretch')}
          >
            <View style={ { marginBottom: Platform.OS === 'web' ? '50px' : '10%' } }>
              <OAboutButton title="Что такое олонхо?" onPress={ () => navigation.navigate('AboutOlonkho') }/>
              <OAboutButton title="Олонхосут И.И. Бурнашев – Тонг Суорун и его олонхо «Сын лошади Богатырь Дыырай»" onPress={ () => navigation.navigate('AboutOlonkhosut') }/>
            </View>
            <OButton title="Текст олонхо" onPress={() => navigation.navigate('Viewer', { line: -1 })}/>
            <OButton title="Раздел практических занятий" onPress={() => navigation.navigate('Lessons')}/>
            <OButton title="О проекте" onPress={() => navigation.navigate('About')}/>
            { Platform.OS === 'web' && 
              <View style={ { position: 'absolute', bottom: 30, alignSelf: 'center', paddingHorizontal: 20 } }>
                <Button title="Скачать мобильное приложение" type="clear" titleStyle={ { color: '#3c5f42' } } onPress={ () => { Linking.openURL("https://cloud.mail.ru/public/cQ1X/cV4fbETw6"); } }/>
              </View>
            }
          </ImageBackground>
        </View>
      );
}